import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { HttpcallService } from '../../common/services/httpcall.service';
import { LoginService } from '../../common/services/Login.service';
import { OpenLinkById } from '../../common/services/openlinkbyid';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';
import { SessionService } from '../../common/services/Session.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  UserContent;
  constructor(
    public commonDataService: CommonDataService,
    public loginService: LoginService, private graphQlService: GraphqlService, private httpCallService: HttpcallService, private domSanitizer: DomSanitizer, private session: SessionService,
    private route: Router, private openlink: OpenLinkById
  ) {
  }

  header: string = "";
  AboutGars: string = "";
  description: string = "";
  history: string = "";
  historyDesc: string = "";
  completeHistory: string = "";
  bookmark: string = "";
  bookmarkDesc: string = "";
  viewAllBookmark: string = "";
  whatsNew: string = "";
  whatsNewDesc: string = "";
  whatsNewDescOP: string = "";
  helpTitle: string = "";
  helpDescription: string = "";
  whatIsCod: string = "";
  whatIsCodDesc: string = "";
  faq: any;
  helpTopics: any = "";
  accessType: string = "";
  howToUse: string = "";
  howToUseDesc: string = "";
  basicUserGuide: any;
  proUserGuide: any;
  howToUseCod: string = "";
  infoPdfUpdate
  userAccountId: string = "";
  userId: string = "";
  newUser: boolean = true;
  myHistory;
  topBookmark;
  basicView: boolean = false;
  outcome: boolean = false;
  licenseeView: boolean = false;
  licenseeTitle: string = "Licensee";
  maintenanceFlag: boolean = false;
  maintenanceMessage: string = "";
  ngOnInit(): void {    
    this.commonDataService.showLoader.next(true);
    this.checkSession();
    const isContactUsRoute = this.route.url?.includes('contact-us');
    if (isContactUsRoute) {
      this.openRightOverlayForContactUs();
    }
  }

  openRightOverlayForContactUs() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("Contact Support");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
  }

  userInfo: any;
  checkSession() {
    if ((this.session.userInfo == undefined || this.session.userInfo.user == null) && this.loginService) {
      //NOSONAR typescript:S1854
      this.loginService.getSession().subscribe(data => {
        this.session.assignUserInfo(data.user);
        this.HomePageHttpCalls(data);
        this.userInfo = data.user;
      })
    }
    else {
      this.userInfo = this.session.userInfo.user;
      this.HomePageHttpCalls(this.session.userInfo);
    }
  }
  HomePageHttpCalls(data) {

    if (data.user.roles == "Basic") {
      this.accessType = "Basic";
      this.basicView = true;
      this.newUser = false;
      forkJoin([
        this.graphQlService.getHomePageComponents(),
      ]).subscribe(([homePageData]) => {
       
        // homePageData.forEach(res => {
        //   if(res?.request!=null && res.request!="" && res.request!=undefined && res?.request=="whatsnewresponse"){
        //     FinalPronouncement=res?.response;
        //   }
        // });
        var home=homePageData?.filter(x=>x.customMetas?.edges?.some(y=>y.node.value=="Garshomepagelabels"));
        var whatlinkshere=homePageData?.filter(x=>x.customMetas?.edges.some(y=>y.node.value=="GarsWhatsNewinThisUpdateLinks"));
        var helpcomponent = homePageData?.filter(x => x.customMetas?.edges?.some(y => y.node.value =="GARSHomePageHelpComponent"));
       
        this.getHomePageLabel(home);
        this.getWhatsNewData(whatlinkshere);
        this.getFinalPronouncement();
        this.getHelpComp(helpcomponent);
        this.outcome = true; 
        this.commonDataService.showLoader.next(false); 
      }, err => { console.log(err); this.commonDataService.showLoader.next(false); });
    }
    else if (data.user.roles == "Professional") {
      this.basicView = false;
      this.accessType = "Professional";
      this.userAccountId = data.user.email;
      this.userId = data.user.firstname + " " + data.user.lastname;
      this.newUser = false;
      this.commonDataService.userId.next(data.user.firstname + " " + data.user.lastname);
      this.commonDataService.mailId.next(data.user.email);
      if (!this.newUser) {
        forkJoin([
          this.httpCallService.getTopAnnotation(),
          this.httpCallService.getMyHistory(),
          this.httpCallService.getTopBookmark(),
          this.graphQlService.getHomePageComponents(),
        ]).subscribe(([myAnnotation, myHistory, myBookmark, homePageData]) => { 
          this.licenseeView = data.user.showLicensee;//data.user.isUserBypassed || data.user.isAdmin;
          // homePageData.forEach(res => {
          //   if(res?.request!=null && res.request!="" && res.request!=undefined && res?.request=="whatsnewresponse"){
          //     FinalPronouncement=res?.response;
          //   }
          // });
          var home=homePageData?.filter(x=>x.customMetas?.edges?.some(y=>y.node.value=="Garshomepagelabels"));
          var whatlinkshere=homePageData?.filter(x=>x.customMetas?.edges?.some(y=>y.node.value=="GarsWhatsNewinThisUpdateLinks"));
          var helpcomponent=homePageData?.filter(x=>x.customMetas?.edges?.some(y=>y.node.value=="GARSHomePageHelpComponent"));
          this.getTopAnnotationHistoryCombination(myHistory, myAnnotation); 
          this.getTopBookmark(myBookmark); 
          this.getHomePageLabel(home);
          this.getWhatsNewData(whatlinkshere);
          this.getFinalPronouncement();
          this.getHelpComp(helpcomponent);
          this.outcome = true; 
          this.commonDataService.showLoader.next(false) 
        }, err => { console.log(err); this.commonDataService.showLoader.next(false); });
      }
      else {
        forkJoin([
          this.graphQlService.getHomePageComponents(),
        ]).subscribe((homePageData) => {
          var home = homePageData?.filter(x => x.customMetas.edges.some(y => y.node.value == "Garshomepagelabels"));
          var whatlinkshere = homePageData?.filter(x => x.customMetas?.edges?.some(y => y.node.value == "GarsWhatsNewinThisUpdateLinks"));
          var helpcomponent = homePageData?.filter(x => x.customMetas?.edges?.some(y => y.node.value == "GARSHomePageHelpComponent"));
          this.getFinalPronouncement();
          this.getHelpComp(helpcomponent);
          this.getHomePageLabel(home);
          this.getWhatsNewData(whatlinkshere);
          this.outcome = true;
          this.commonDataService.showLoader.next(false);
        }, err => { console.log(err); this.commonDataService.showLoader.next(false); });
      }
    }
    else if (data.user.roles == "Academic") {
      this.accessType = "Academic";
      this.userAccountId = data.user.email;
      this.userId = data.user.firstname + " " + data.user.lastname;
      this.basicView = false;
      this.newUser = data.user.newUser;
      if (!this.newUser) {
        forkJoin([
          this.httpCallService.getTopAnnotation(),
          this.httpCallService.getMyHistory(),
          this.graphQlService.getHomePageComponents(),
        ]).subscribe(([myAnnotation, myHistory, homePageData]) => {
          var home = homePageData?.filter(x => x.customMetas?.edges?.some(y => y.node.value == "Garshomepagelabels"));
          var whatlinkshere = homePageData?.filter(x => x.customMetas?.edges?.some(y => y.node.value == "GarsWhatsNewinThisUpdateLinks"));
          var helpcomponent = homePageData?.filter(x => x.customMetas?.edges?.some(y => y.node.value == "GARSHomePageHelpComponent"));
          this.getTopAnnotationHistoryCombination(myHistory, myAnnotation);
          this.getHomePageLabel(home);
          this.getWhatsNewData(whatlinkshere);
          this.getFinalPronouncement();
          this.getHelpComp(helpcomponent);
          this.outcome = true;
          this.commonDataService.showLoader.next(false)
        }, err => { console.log(err); this.commonDataService.showLoader.next(false); });
      }
    }

  }

  getTopAnnotationHistoryCombination(myHistory: any, myAnnotation: any) {
    this.myHistory = [];
    this.myHistory.push.apply(this.myHistory, myHistory);
    this.myHistory.push.apply(this.myHistory, myAnnotation);
    this.myHistory.sort((a: any, b: any) => {
      return (new Date(a.recentDate).getTime()) - (new Date(b.recentDate).getTime());
    });
    this.myHistory = this.myHistory.reverse().slice(0, 5);
  }

  howToUseDescArr1: string = "";
  helpTopicText: string = "";
  howToUseDescArr2: string = "";
  proViewUserGuide: string = "";
  howToUseDescArr3: string = "";
  infoUpdatedDate: string = "";
  infoPdfUpdatelink: string = "";
  infoPdfUpdatelinkText: string = "";
  infoDot: string = "";
  resetPassword: string = "";
  launchmessage
  getHomePageLabel(data) {
    if (data != "") {
      var labels = data[0].content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.infoUpdatedDate = labels.filter(x => x.key == "home_dateUpdated").map(y => y.value);
      this.description = labels.filter(x => x.key == "home_headerDsicription").map(y => y.value);
      this.resetPassword = labels.filter(x => x.key == "resetPasswordLabel").map(y => y.value);
      this.AboutGars = labels.filter(x => x.key == "home_AboutGars").map(y => y.value);
      this.history = labels.filter(x => x.key == "home_history").map(y => y.value);
      this.historyDesc = labels.filter(x => x.key == "home_historyDescription").map(y => y.value);
      this.completeHistory = labels.filter(x => x.key == "home_completeHistory").map(y => y.value);
      this.bookmark = labels.filter(x => x.key == "home_bookmarks").map(y => y.value);
      this.bookmarkDesc = labels.filter(x => x.key == "home_bookmarksDescription").map(y => y.value);
      this.viewAllBookmark = labels.filter(x => x.key == "home_allBookmarks").map(y => y.value);
      this.whatsNew = labels.filter(x => x.key == "home_whatNew").map(y => y.value);
      this.whatsNewDesc = labels.filter(x => x.key == "home_whatNewDescription").map(y => y.value);
      this.whatsNewDescOP = labels.filter(x => x.key == "home_whatNewDescription_OP").map(y => y.value);
      this.helpTitle = labels.filter(x => x.key == "home_helpTitle").map(y => y.value);
      this.helpDescription = labels.filter(x => x.key == "home_helpDescription").map(y => y.value);
      this.whatIsCod = labels.filter(x => x.key == "home_headerWhatIsGARS").map(y => y.value);
      this.whatIsCodDesc = labels.filter(x => x.key == "home_descriptionWhatIsGARS").map(y => y.value);
      this.howToUse = labels.filter(x => x.key == "home_headerHowToUse").map(y => y.value);
      this.faq = this.domSanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_FAQ").map(y => y.value));
      this.helpTopics = labels.filter(x => x.key == "home_helpTopics").map(y => y.value);
      this.basicUserGuide = this.domSanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_basicUserGuide").map(y => y.value));
      this.proUserGuide = this.domSanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_proUserGuide").map(y => y.value));
      this.howToUseCod = labels.filter(x => x.key == "home_howToUseCod").map(y => y.value); 
      this.infoDot = labels.filter(x => x.key == "home_infoDot").map(y => y.value);
      this.launchmessage = this.domSanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_launchmessage").map(y => y.value));
      this.infoPdfUpdate = this.domSanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_infoPdfUpdate").map(y => y.value));
      this.maintenanceMessage = labels.filter(x => x.key == "maintenanceMessage").map(y => y.value);
      
      this.maintenanceFlag = labels.filter(x => x.key == "maintenanceflag").map(x => x.value.toLowerCase() === "true")[0];

      //this.infoPdfUpdatelink = "['/" + labels.filter(x => x.key == "home_toclink").map(y => y.value).toString().split(",")[0] + "']";
      this.infoPdfUpdatelinkText =labels.filter(x => x.key == "home_toclink").map(y => y.value) ;
    

      if (this.accessType == "Basic") {
        this.header = labels.filter(x => x.key == "home_headerWelcomeBasicView").map(y => y.value);
        this.howToUseDesc = labels.filter(x => x.key == "home_descriptionHowToUseBasic").map(y => y.value);
        this.howToUseDescArr1 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[0];
        this.helpTopicText = "Help Topics";
        this.howToUseDescArr2 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[1].split("[Basic_View_User_Guide_link]")[0];
        this.proViewUserGuide = "Basic View User Guide";
        this.howToUseDescArr3 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[1].split("[Basic_View_User_Guide_link]")[1];
      }
      else if (this.accessType == "Professional" || this.accessType == "Academic") {
        this.howToUseDesc = labels.filter(x => x.key == "home_descriptionHowToUsePro").map(y => y.value);
        this.howToUseDescArr1 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[0];
        this.helpTopicText = "Help Topics";
        this.howToUseDescArr2 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[1].split("[Pro_View_User_Guide_link]")[0];
        this.proViewUserGuide = "Pro View User Guide";
        this.howToUseDescArr3 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[1].split("[Pro_View_User_Guide_link]")[1];
        this.header = labels.filter(x => x.key == "home_headerWelcome").map(y => y.value);
        //if (this.newUser) {
        //  this.header = labels.filter(x => x.key == "home_headerWelcome").map(y => y.value);
        //}
        //else {
        //  this.header = labels.filter(x => x.key == "home_headerWelcomeBack").map(y => y.value);
        //}
        this.header = this.header.toString().replace("[USER_NAME]", this.userId);
      }
    }
  }
  contentlinks;
  whatsNewContentOP = [];
  whatsNewContent = [];
  publiccommentlink;
  whatsNewContent1 = [];
  finalpronouncementlink;
  whatsNewContent2 = [];
  getWhatsNewData(data) {
    if (data.length != 0){
      var linkItems = data[0].content.data.linkItem;
      var linklist = linkItems.map(y => ({ linkText: y.linkText, externalLink: y.externalLink }));
      for (var i = 0; i < linklist.length; i++) {
        if (i < (linklist.length - 2)) {
          this.contentlinks = { "fileName": linklist[i].linkText, "externalLink": linklist[i].externalLink };
          this.whatsNewContent.push(this.contentlinks);
        }
        else if (i == (linklist.length - 1)) {
          this.finalpronouncementlink = { "fileName": linklist[i].linkText, "externalLink": linklist[i].externalLink };
          this.whatsNewContent2.push(this.finalpronouncementlink);
        }
        else {
          this.publiccommentlink = { "fileName": linklist[i].linkText, "externalLink": linklist[i].externalLink };
          this.whatsNewContent1.push(this.publiccommentlink);
        }
      }
    }
    
    // this.graphQlService.getPronouncementsfromGeneralSites(true).subscribe(data => {
    //   let result = data.result
    //   console.log(result);
    //   this.whatsNewContent = result;
    // })
  }

  getFinalPronouncement(){
    this.graphQlService.getpronouncements("CODCIG", true).subscribe(data => {
      this.whatsNewContent = data.result;
    })
    this.graphQlService.getpronouncements("OP", true).subscribe(data => {
      this.whatsNewContentOP = data.result;
    })
  }
  ResetPassword() {
    this.commonDataService.showLoader.next(true);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.session.assignUserInfo(data.user);
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.userData.next(data.user);
        this.commonDataService.rightPanelWidth.next("rightOverLay_small");
        this.commonDataService.rightOverlayOption.next("addUpdateUser");
      })
    }
    else {
      this.commonDataService.showRightPanel.next(true);
      this.commonDataService.userData.next(this.session.userInfo.user);
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.commonDataService.rightOverlayOption.next("addUpdateUser");
    }
  }
  licensee: any;
  getHelpComp(data) {
    if (data != "" && data.length != 0) {
      var labels = data[0].content.data;

      this.basicUserGuide = labels.helpBasicUserGuide;
      this.faq =labels.helpFaq;
      this.helpTopics = labels.helpTopics;
      this.proUserGuide = labels.helpProUserGuide;
      this.licensee=labels.helpLicenseeTitle;
      this.helpTopicText = this.helpTopics.linkText;
      this.proViewUserGuide = this.accessType == "Basic" ? this.basicUserGuide.linkText : this.proUserGuide.linkText;
    }
  }

  getHistory(resp) {
    //this.myHistory = [
    //  { "recentDate": "08/17/2021 17: 07: 41", "breadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background,Paragraph 1", "pageURL": "/17765/17752/codification/general", "historyType": "VisitedPages", "historyTitle": "Paragraph 1" },
    //  { "recentDate": "08/17/2021 17: 07: 41", "breadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background,Paragraph 1", "pageURL": "/17765/17752/codification/general", "historyType": "VisitedPages", "historyTitle": "Paragraph 2" },
    //  { "recentDate": "08/17/2021 17: 07: 41", "breadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background,Paragraph 1", "pageURL": "/17765/17752/codification/general", "historyType": "VisitedPages", "historyTitle": "Paragraph 3" },
    //  { "recentDate": "08/17/2021 17: 07: 41", "breadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background,Paragraph 1", "pageURL": "/17765/17752/codification/general", "historyType": "Annotation", "historyTitle": "Test Annotation" },
    //  { "recentDate": "08/17/2021 17: 07: 41", "breadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background,Paragraph 1", "pageURL": "/17765/17752/codification/general", "historyType": "Bookmark", "historyTitle": "Test Bookmark" },
    //];
    //console.log(this.myHistory);
    this.myHistory = resp;
  }

  getTopBookmark(resp) {
    //this.topBookmark = [
    //  { "recentDate": "08/17/2021 17: 07: 41", "breadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background,Paragraph 1", "pageURL": "/17765/17752/codification/general", "historyType": "Bookmark", "historyTitle": "Test Bookmark 1" },
    //  { "recentDate": "08/17/2021 17: 07: 41", "breadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background,Paragraph 1", "pageURL": "/17765/17752/codification/general", "historyType": "Bookmark", "historyTitle": "Test Bookmark 2" },
    //  { "recentDate": "08/17/2021 17: 07: 41", "breadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background,Paragraph 1", "pageURL": "/17765/17752/codification/general", "historyType": "Bookmark", "historyTitle": "Test Bookmark 3" },
    //];
    //console.log(this.topBookmark)

    this.topBookmark = resp;
  }


  ViewAllBookmark() {
    this.route.navigateByUrl("/myBookmarks");
  }

  ViewCompleteHistory() {
    this.route.navigateByUrl("/MyHistory");
  }
  NavigateToHelp() {
    this.route.navigateByUrl("/help");
  }
  NavigateToUnderDevelopment() {
    this.route.navigateByUrl("/UnderDevelopment");
  }
  NavigateToFinalPronouncement() {
    this.route.navigateByUrl("/finalpronouncements");
  }

  NavigateToNotificationLink(event) {
    event.preventDefault();
    this.route.navigateByUrl(event.target.getAttribute('href'));
  }

  redirectToBookmarkUrl(bookmark,event) {
    event.preventDefault();
    this.route.navigateByUrl(bookmark.pageURL);
  }

  redirectToHistoryUrl(history, event) {
    event.preventDefault();
    this.route.navigateByUrl(history.pageURL);
  }

  openLinkById(event, isSitesBucket = false) {
    event.preventDefault();
    let id = event.target.getAttribute('id');
    if ((id.includes('.')) && (id.split('.').pop() === 'pdf')) {
      let url = '/layoutComponents/getPdf?isSitesBucket=' + isSitesBucket +'&fileName=' + id;//show pdf
       window.open(url);
    }
    else {
      this.openlink.openLinkById(event, isSitesBucket);
    }
  }
  onRightClick(event, data?: any) {
    if (data != null && data != 'SitesPdf' && data != 'DocsPdf') {
      event.srcElement.setAttribute('href',data?.pageURL);
    }
    else {
      let id = event.target.getAttribute('id');
      if (id != null && id.trim()[0] === '/') {
        event.srcElement.setAttribute('href',id);
      }
      else if((id.includes('.')) && (id.split('.').pop() === 'pdf')) {
        let url="";
        if(data == 'SitesPdf'){
          url = '/layoutComponents/getPdf?isSitesBucket=' + true +'&fileName=' + id;//show pdf
        }
        else if(data=='DocsPdf'){
          url = '/layoutComponents/getPdf?isSitesBucket=' + false +'&fileName=' + id;//show pdf
        }
        event.srcElement.setAttribute('href',url);
      }
      else{
        event.target.setAttribute("href",id)
      }
    }
  }
}
